<section class="section cta-banner fluid-bg-vibrant">
  <div class="container text-center reveal">
    <div class="cta-inner glass-card">
      <h2 class="section-title" style="background: none; -webkit-text-fill-color: #fff; text-shadow: 0 0 20px rgba(0, 242, 254, 0.5);">
        Ready to transform your enterprise communication?
      </h2>
      <p class="section-subtitle" style="color: rgba(255, 255, 255, 0.9);">
        Join the thousands of businesses running seamlessly on KOTHA IP Telephony.
      </p>
      <a href="#contact-form" class="btn btn-outline btn-lg" style="border-color: #fff; background: rgba(255, 255, 255, 0.1); color: #fff;">Get a Custom Quote Today</a>
    </div>
  </div>
</section>
